import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { FormErrorMessages } from './form-error-messages';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { FormValidationUtils } from '../../../utils/form-validation-utils';

@Component({
  selector: 'app-form-error',
  templateUrl: './form-error.component.html',
  styleUrls: ['./form-error.component.scss'],
  standalone: true,
  imports: [AsyncPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormErrorComponent implements OnChanges {
  @Input() errors: ValidationErrors | null = null;
  @Input() customErrorMessages: FormErrorMessages | null = null;

  private defaultErrorMessages = FormValidationUtils.DEFAULT_FORM_ERROR_MESSAGES;

  protected _errors = new BehaviorSubject<ValidationErrors | null>(null);
  public errors$ = this._errors as Observable<ValidationErrors | null>;

  protected _customErrorMessages = new BehaviorSubject<FormErrorMessages | null>(null);
  public customErrorMessages$ = this._customErrorMessages as Observable<FormErrorMessages | null>;

  public errorMessage$ = combineLatest([this.errors$, this.customErrorMessages$]).pipe(
    map(([errors, customErrorMessages]) => {
      if (!errors || Object.keys(errors).length === 0) {
        return '';
      }

      const errorKey = Object.keys(errors)[0];

      return customErrorMessages?.[errorKey] ?? this.defaultErrorMessages[errorKey] ?? '';
    })
  );

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.errors) {
      this._errors.next(this.errors);
    }
    if (changes.customErrorMessages) {
      this._customErrorMessages.next(this.customErrorMessages);
    }
  }
}
